import { useUBL } from '@common/log-manager';
import { getServerLogForVerticalProductCard, UxGoodsCardItemForVerticalProductCard } from '@common/product-card';
import { getUrl } from '@domains/pdp-common';

export const convertRecommendType = (group_type: string) => group_type.replace('_item_list', '').replace('store_', '');

export const useRecommendTabLog = (originalProductId: string) => {
  const sendUBL = useUBL();

  const commonLog = {
    navigation: 'product_detail',
    navigation_sub: {
      page_url: getUrl(),
    },
    object_section: 'subtab_recommendation',
    object_type: 'catalog',
  };

  const impressionProductItem = ({
    position,
    groupType,
    item,
  }: {
    position: number;
    groupType: string;
    item: UxGoodsCardItemForVerticalProductCard;
  }) => {
    const server_log = getServerLogForVerticalProductCard(item.catalog_product_id, item);

    sendUBL({
      ...commonLog,
      category: 'impression',
      object_idx: position,
      object_id: item.catalog_product_id || '',
      data: {
        original_product_id: originalProductId,
        recommend_type: convertRecommendType(groupType),
        server_log,
      },
    });
  };

  const clickProductItem = ({
    position,
    groupType,
    item,
  }: {
    position: number;
    groupType: string;
    item: UxGoodsCardItemForVerticalProductCard;
  }) => {
    const server_log = getServerLogForVerticalProductCard(item.catalog_product_id, item);

    sendUBL({
      ...commonLog,
      category: 'click',
      object_idx: position,
      object_id: item.catalog_product_id || '',
      data: {
        original_product_id: originalProductId,
        recommend_type: convertRecommendType(groupType),
        server_log,
      },
    });
  };

  const savedProduct = ({
    category,
    position,
    groupType,
    item,
  }: {
    category: 'save_product' | 'remove_saved_product';
    position: number;
    groupType: string;
    item: UxGoodsCardItemForVerticalProductCard;
  }) => {
    const server_log = getServerLogForVerticalProductCard(item.catalog_product_id, item);
    sendUBL({
      ...commonLog,
      category,
      object_id: item.catalog_product_id || '',
      object_idx: position,
      data: {
        original_product_id: originalProductId,
        recommend_type: convertRecommendType(groupType),
        server_log,
      },
    });
  };

  const viewMore = () =>
    sendUBL({
      category: 'click',
      navigation: 'product_detail',
      object_section: 'subtab_recommendation',
      object_type: 'button',
      object_id: 'see_more_item',
    });

  return {
    impressionProductItem,
    clickProductItem,
    savedProduct,
    viewMore,
  };
};
